import { bridge } from '@dc-platform/dc-bridge'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageName = require('../package.json').name // 这里是为了获取package的name值

bridge.init()
bridge.setChildName(packageName)
